import { Spacing16, Spacing8 } from 'autogen/design-tokens/tokens';
import type { BasketLineModifiedResultViewModel } from 'autogen/swagger/all';
import Flex from 'components/Layout/components/Flex';
import Card from 'components/generic/card';
import ProductImage from 'components/generic/productImage';
import { Typography } from 'components/generic/typography';
import formatHtml from 'helpers/translations';
import styled, { css } from 'styled-components';
import { breakpoint, sizes } from 'variables';

const ProductImageContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Grid = styled.div`
    display: grid;
    gap: ${Spacing16};
    grid-template-columns: 104px 1fr;

    ${breakpoint.up(sizes.lg)} {
        align-items: start;
        grid-template-columns: 104px 1fr;
    }
`;

export default function ModifiedBasketItem({
    model: { primaryImageRawImageUrl, productName, modificationReasonText }
}: {
    model: BasketLineModifiedResultViewModel;
}) {
    return (
        <Card size={null}>
            <Card.Content>
                <Flex.Column>
                    <Grid>
                        <ProductImageContainer>
                            <ProductImage
                                width={104}
                                image={{ url: primaryImageRawImageUrl, imageType: 'PrimaryImage' }}
                                transformType="SquareScale"
                            />
                        </ProductImageContainer>

                        <Flex.Column gap={Spacing8}>
                            <Typography.Body as="span">{productName}</Typography.Body>
                            <Typography.Body
                                as="span"
                                css={css`
                                    font-style: italic;
                                `}
                                size="S"
                            >
                                {formatHtml(modificationReasonText)}
                            </Typography.Body>
                        </Flex.Column>
                    </Grid>
                </Flex.Column>
            </Card.Content>
        </Card>
    );
}
